import Backbone from 'backbone'
import _ from 'lodash'
import icon from 'scoreboard/components/icon'
import $ from 'jquery'
import { isV6 } from 'scoreboard/components/version'


var MultipleChoiceOption = Backbone.View.extend({
	className: 'config-multiple-choice',
	tagName: 'ul',

	events: {
		'click li': 'select'
	},

	initialize: function (options = {}) {
		this.options = options
	},

	render: function () {
		var props = this.model.properties.toJSON()
		var current = props[this.property] || this.defaultValue
		// Wrapper for the choice items which sets the selected state based on the model
		var choiceListItems = $('<span></span>')
			.addClass('choice-wrapper ' + props.fill + ' ' + props.shape)

		var choices = _.map(_.result(this, 'choices'), function (choice) {
			// Handle cases where there are multiple icons to show for each
			// choice option.
			if (typeof(choice) === 'object') {
				var html = ''
				_.each(choice.icons, function(iconName) {
					html += icon(iconName, iconName)
				})
				let listClasses = ''
				if (isV6()) {
					listClasses += ' button-boolean'
				}

				return $(`<li class="${listClasses}"></li>`)
					.toggleClass('selected', choice.label == current)
					.data('value', choice.label)
					.append(html)
			}

			return $('<li></li>')
				.toggleClass('selected', choice == current)
				.data('value', choice)
				.append(icon(choice, choice))
		})

		// Wrap li choices into the .choice-wrapper
		choiceListItems.append(choices)

		this.$el.append(choiceListItems)

		return this
	},

	select: function (e) {
		var selected = $(e.currentTarget).data('value')
		this.$('li').each(function () {
			var li = $(this)
			li.toggleClass('selected', selected == li.data('value'))
		})

		this._updateModel(selected)

		if (this.afterSelect) {
			this.afterSelect(selected)
		}
	},

	_updateModel(selected) {
		this.options.widgetUpdater.setProperty(this.property, selected)
	}
})

export default MultipleChoiceOption

MultipleChoiceOption.__filename__ = 'dashboards/widgets/multiple-choice-option.js'
